import styled from 'styled-components';
import { getSpacing } from '../../../styles/spacing.js';
import { Button } from '../../Button/Button.js';
import { IconArrowDown } from '../../Icons/IconArrowDown.js';
import { IconArrowUp } from '../../Icons/IconArrowUp.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var StyledWheel = styled.div.withConfig({
  displayName: "DatePickerWheel__StyledWheel",
  componentId: "sc-1mn6c54-0"
})(function (_ref) {
  var $disabled = _ref.$disabled,
    theme = _ref.theme;
  return {
    color: $disabled ? theme.neutralColors.rhino : void 0,
    width: getSpacing(8)
  };
});
var StyledWheelValue = styled.input.withConfig({
  displayName: "DatePickerWheel__StyledWheelValue",
  componentId: "sc-1mn6c54-1"
})({
  display: "block",
  textAlign: "center",
  maxWidth: "80%",
  margin: "0 auto !important",
  border: 0
});
var DatePickerWheel = function DatePickerWheel(_ref2) {
  var disabled = _ref2.disabled,
    labelDecrease = _ref2.labelDecrease,
    labelIncrease = _ref2.labelIncrease,
    labelInput = _ref2.labelInput,
    onDecrease = _ref2.onDecrease,
    onIncrease = _ref2.onIncrease,
    value = _ref2.value;
  return /*#__PURE__*/jsxs(StyledWheel, {
    $disabled: disabled,
    children: [/*#__PURE__*/jsx(Button, {
      disabled: disabled,
      hideLabel: true,
      label: labelIncrease,
      onClick: onIncrease,
      startAdornment: IconArrowUp,
      variant: "ghost"
    }), /*#__PURE__*/jsx(StyledWheelValue, {
      disabled: disabled,
      value: value,
      readOnly: true,
      "aria-label": labelInput
    }), /*#__PURE__*/jsx(Button, {
      disabled: disabled,
      hideLabel: true,
      label: labelDecrease,
      onClick: onDecrease,
      startAdornment: IconArrowDown,
      variant: "ghost"
    })]
  });
};
DatePickerWheel.displayName = "DatePickerWheel";

export { DatePickerWheel };
